module.exports = __webpack_public_path__ + "img/title.0ca32258.jpg";